
import * as THREE from 'three';
import Phobject from './Phobject.js'

export default class Desk extends Phobject {
    constructor(){
        super(true);
        let toM = function(n){
            return n/39.37;
        }
        this.dimDesk = new THREE.Vector3(toM(60), toM(29),toM(27)); //width, height, depth
        this.thickness = toM(2);
        this.group = new THREE.Group();

        // Table top
        var geoTop = new THREE.BoxGeometry( this.dimDesk.x, this.thickness, this.dimDesk.z);
        var matWood = new THREE.MeshPhongMaterial( {color: 0xFFFFFF, side: THREE.DoubleSide});
        let meshTop = new THREE.Mesh( geoTop, matWood );
        meshTop.position.y = this.dimDesk.y/2-toM(this.thickness)/2;
        
        // table base
        var geoLeg = new THREE.BoxGeometry( this.thickness, this.dimDesk.y, this.dimDesk.z);
        let meshLegLeft = new THREE.Mesh( geoLeg, matWood );
        meshLegLeft.position.x = -this.dimDesk.x/2+this.thickness/2;

        let meshLegRight = new THREE.Mesh( geoLeg, matWood );
        meshLegRight.position.x = this.dimDesk.x/2-this.thickness/2;

        this.group.add(meshTop);
        this.group.add(meshLegLeft);
        this.group.add(meshLegRight);
    }

    getObject(){
        return this.group;
    }

    setupPhysics(pos){
        this.group.position.copy(pos);
        // physics
        var options = {
            type:'box',
            size:[this.dimDesk.x,this.dimDesk.y+this.thickness, this.dimDesk.z], 
            pos:[pos.x,pos.y,pos.z],
            density:5,
            move:this.move
        }
    
        this.phobject = this.world.add( options );
    }
}
